import type { ComponentPropsWithRef } from "react";
import { styled } from "styled-components";

import { linkStyles } from "common/styles";

export const Link = (props: ComponentPropsWithRef<"a">) => <Anchor {...props} />;

const Anchor = styled.a`
  ${linkStyles}
`;
